var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "allfwlist" }, [
    _c(
      "div",
      { staticClass: "search" },
      [
        _c("svgicon", {
          attrs: {
            name: "search",
            width: ".38rem",
            height: ".38rem",
            color: "#9fa2a3",
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.title,
              expression: "title",
            },
          ],
          staticClass: "search-input",
          attrs: { type: "text", placeholder: "输入小区或商圈开始找房咯~" },
          domProps: { value: _vm.title },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.title = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "search-btn", on: { click: _vm.search } }, [
          _vm._v("搜索"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "list" },
      [
        _vm._l(_vm.list, function (house, index) {
          return _c(
            "div",
            { key: index },
            [
              house.type == "新房"
                ? _c("houseItemNew", {
                    attrs: { house: house, type: _vm.$route.query.type },
                    on: { handleHosue: _vm.handleHosue },
                  })
                : _c("house-item", {
                    attrs: { house: house, type: _vm.$route.query.type },
                    on: { handleHosue: _vm.handleHosue },
                  }),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.hasMore
          ? _c("div", { staticClass: "next", on: { click: _vm.nextPage } }, [
              _vm._v("下一页"),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v(" 暂无数据 ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }